import type { OfflineIntentStatus, OfflineQueueRecord } from "../../types/requisition";
import { getOfflineRecord, listOfflineRecords, upsertOfflineRecord } from "./schema";

export async function appendQueuedIntent(intent: OfflineQueueRecord): Promise<OfflineQueueRecord> {
  await upsertOfflineRecord("requisitionQueue", intent.id, intent);
  return intent;
}

export async function getQueuedIntent(queueId: string): Promise<OfflineQueueRecord | undefined> {
  return getOfflineRecord<OfflineQueueRecord>("requisitionQueue", queueId);
}

export async function listQueuedIntents(): Promise<OfflineQueueRecord[]> {
  const intents = await listOfflineRecords<OfflineQueueRecord>("requisitionQueue");
  return intents.sort((left, right) => left.eventSequence - right.eventSequence);
}

export async function listQueuedIntentsByStatus(status: OfflineIntentStatus): Promise<OfflineQueueRecord[]> {
  const intents = await listQueuedIntents();
  return intents.filter((intent) => intent.status === status);
}

export async function updateQueuedIntent(intent: OfflineQueueRecord): Promise<OfflineQueueRecord> {
  await upsertOfflineRecord("requisitionQueue", intent.id, intent);
  return intent;
}
